import { useMutation } from '@tanstack/react-query';

import { FlightOperationNotificationClient, FlightEventFlightDetailsLookup } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightOperationNotificationClient = new FlightOperationNotificationClient(apiBaseUrl);

function useCreateNewFlightOperationNotification() {
  return useMutation({
    mutationKey: [queryKeys.FlightOperationNotification.CreateNew],
    mutationFn: (lookup: FlightEventFlightDetailsLookup) => flightOperationNotificationClient.createNew(lookup),
  });
}

export default useCreateNewFlightOperationNotification;
